import { defineGetter } from './define-getter'

export default function DependentValue({
  obj,
  key,
  dependency,
  dependent
}) {
  let lastDep = undefined
  let lastVal = undefined
  defineGetter({ obj, key, get })
  return obj

  function get() {
    const currDep = dependency()
    if (currDep !== lastDep) {
      const currVal = dependent(currDep)
      lastDep = currDep
      lastVal = currVal
    }
    return lastVal
  }
}
